import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import TeamMembersPanel from '../../team/TeamMembersPanel';

const TeamTab = ({
  displayTeam,
  teamLoading,
  isReadOnly,
  onAddMember,
  onRemoveMember,
  onOpenSettings,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-slate-900">Team Management</h2>
        {!isReadOnly && (
          <button
            onClick={onAddMember}
            className="flex items-center space-x-2 rounded-xl bg-slate-900 px-4 py-2 text-white transition-opacity hover:opacity-90"
          >
            <Plus className="h-4 w-4" />
            <span>Add Team Member</span>
          </button>
        )}
      </div>

      {teamLoading ? (
        <div className="rounded-2xl border bg-white p-6 text-slate-600">
          <div className="flex items-center justify-center">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
              className="h-6 w-6 rounded-full border-2 border-slate-300 border-t-slate-600"
            ></motion.div>
            <span className="ml-3">Loading team...</span>
          </div>
        </div>
      ) : (
        <TeamMembersPanel
          team={displayTeam}
          onRemove={onRemoveMember}
          onOpenSettings={onOpenSettings}
          isReadOnly={isReadOnly}
        />
      )}
    </motion.div>
  );
};

export default TeamTab;
